<template>
  <ValidationObserver ref="form" tag="div">
    <b-form class="share-modal-form"
      ><label
        class="custom-radio form-row align-items-center"
        v-for="(item, index) in shareOptions"
        :key="index"
      >
        <div class="col-lg-1"></div>
        <div class="col-lg-4">
          <input
            class="custom-control-input"
            type="radio"
            v-model="radioValue"
            name="some-radios"
            :value="item.email"
          /><span class="custom-control-label">{{ item.name }}</span>
        </div>
        <div class="col-lg-4">
          <div class="text-center current-email">{{ item.email }}</div>
        </div>
        <div class="col-lg-1"></div>
        <div class="col-lg-1">
          <svg width="54" height="54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27 53.15h0C41.435 53.133 53.133 41.435 53.15 27v0C53.15 12.558 41.442.85 27 .85 12.558.85.85 12.558.85 27 .85 41.442 12.558 53.15 27 53.15zM3.04 27C3.04 13.768 13.769 3.04 27 3.04 40.226 3.057 50.944 13.775 50.96 27 50.958 40.232 40.231 50.96 27 50.96 13.768 50.96 3.04 40.231 3.04 27z" fill="#75B9FF" stroke="#75B9FF" stroke-width=".3"/><path d="M10.16 47h0a1.096 1.096 0 01-.014-1.663c.427-.38.895-.712 1.395-.99h.001l7.476-4.077s0 0 0 0a1.958 1.958 0 001.02-1.72v-2.686a17.897 17.897 0 01-2.906-6.004 3.592 3.592 0 01-1.284-2.753v-3.352 0c.003-.84.3-1.652.838-2.295V17.11a7.776 7.776 0 011.816-5.647l.002-.002h0C20.285 9.427 23.156 8.413 27 8.413c3.844 0 6.715 1.014 8.496 3.047l.002.002h0a7.776 7.776 0 011.816 5.647v4.351c.538.643.835 1.455.838 2.295h0v3.352h-.15a3.432 3.432 0 01-1.971 3.11L10.16 47zm0 0A26.172 26.172 0 0027 53.15h0a26.175 26.175 0 0016.74-6.064h0a1.095 1.095 0 00.005-1.678 7.745 7.745 0 00-1.533-1.026h-.001l-8.005-4.003h0a1.946 1.946 0 01-1.082-1.75v0-2.743c.177-.221.364-.469.555-.74h0a19.435 19.435 0 002.473-4.821L10.16 47zm20.923-8.371h-.15v0-3.141c0-.266.096-.522.27-.722.244-.283.473-.578.687-.885h0a17.324 17.324 0 002.34-4.717h0c.11-.34.379-.606.72-.711h0a1.43 1.43 0 001.01-1.347v-3.35c0-.4-.174-.78-.474-1.044l-.002-.001a1.095 1.095 0 01-.362-.813v-4.846a5.639 5.639 0 00-1.291-4.168c-1.329-1.5-3.612-2.28-6.831-2.28-3.232 0-5.522.788-6.848 2.299a5.547 5.547 0 00-1.284 4.009c.006.046.01.093.01.14v4.846c0 .31-.132.605-.363.813l-.001.001h0c-.3.264-.474.644-.475 1.044 0 0 0 0 0 0v3.35s0 0 0 0c.002.483.25.932.657 1.19h0c.24.156.41.397.473.675a15.64 15.64 0 002.809 5.817c.162.198.251.444.252.7h0v3.062s0 0 0 0c0 1.52-.83 2.917-2.163 3.643 0 0 0 0 0 0l-7.373 4.021c8.439 6.29 20 6.33 28.481.1l-7.882-4.11m-2.21-3.575a3.975 3.975 0 002.21 3.576m-2.21-3.576v-3.141c0-.23.083-.451.234-.623l-.234 3.764zm2.21 3.576l-.067.134h0l.067-.134z" fill="#75B9FF" stroke="#75B9FF" stroke-width=".3"/></svg>
        </div>
        <div class="col-lg-1"></div> </label
      ><label class="custom-radio form-row align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-4">
          <input
            class="custom-control-input"
            type="radio"
            v-model="radioValue"
            name="some-radios"
            value="other"
          /><span class="custom-control-label">{{
            $t("create_campaign.other_email")
          }}</span>
        </div>
        <div class="col-lg-4">
          <app-text-input
            :name="$t('general.email')"
            :placeholder="$t('general.email')"
            rules="email"
            vid="email"
            type="text"
            v-model="email"
          ></app-text-input>
        </div>
        <div class="col-lg-1"></div>
        <div class="col-lg-1">
          <svg width="57" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.28 33.229a1.108 1.108 0 100 2.216 1.108 1.108 0 000-2.216zM51.173 8.861H47.85V5.538a1.108 1.108 0 10-2.215 0v3.323h-3.323a1.108 1.108 0 100 2.215h3.323V14.4a1.108 1.108 0 102.215 0v-3.322h3.323a1.108 1.108 0 100-2.216z" fill="#75B9FF"/><path d="M46.742 0c-5.122 0-9.354 3.884-9.906 8.861H3.323A3.325 3.325 0 000 12.184v24.368a3.325 3.325 0 003.323 3.323h41.204c1.886 0 3.323-1.54 3.323-3.323V19.876c4.977-.553 8.861-4.785 8.861-9.907C56.711 4.472 52.24 0 46.742 0zM2.215 12.245l14.93 11.561-14.93 12.559v-24.12zm16.723 12.949l2.919 2.26c.61.486 1.338.729 2.068.729.728 0 1.456-.242 2.065-.726l2.963-2.262L44.227 37.66H4.117l14.82-12.466zm11.825-1.381l8.922-6.81a9.905 9.905 0 005.95 2.873V35.95L30.763 23.813zm-6.127 1.89l-.02.016a1.097 1.097 0 01-1.382 0l-.015-.011c-.011-.01-5.39-4.174-18.895-14.632h32.514a9.999 9.999 0 001.467 4.193L24.636 25.703zm22.106-7.98c-4.274 0-7.753-3.475-7.753-7.754 0-4.275 3.478-7.754 7.753-7.754 4.276 0 7.754 3.479 7.754 7.754 0 4.275-3.478 7.753-7.754 7.753z" fill="#75B9FF"/><path d="M30.57 33.229h-8.86a1.107 1.107 0 100 2.215h8.86a1.108 1.108 0 100-2.215z" fill="#75B9FF"/></svg>
        </div>
        <div class="col-lg-1"></div>
      </label>
      <div class="text-center">
        <b-btn class="share-btn mt-3" variant="primary" @click="emitEmail">{{ $t("create_campaign.send") }}</b-btn>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from "vuex";
import AppTextInput from "../../components/TextInput";
export default {
  components: {
    AppTextInput,
  },
  props: {
    current: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      radioValue: [],
      email: "",
    };
  },
  computed: {
    shareOptions() {
      let array = [];
      if (this.current.info.client_contact_email) {
        array.push({
          email: this.current.info.client_contact_email,
          name:
            this.current.info.client_contact_first_name +
            " " +
            this.current.info.client_contact_last_name,
        });
      }
      if (this.current.info.campaign_admin_1_email) {
        array.push({
          email: this.current.info.campaign_admin_1_email,
          name:
            this.current.info.campaign_admin_1_first_name +
            " " +
            this.current.info.campaign_admin_1_last_name,
        });
      }
      if (this.current.info.campaign_admin_2_email) {
        array.push({
          email: this.current.info.campaign_admin_2_email,
          name:
            this.current.info.campaign_admin_2_first_name +
            " " +
            this.current.info.campaign_admin_2_last_name,
        });
      }
      return array;
    },
  },
  methods: {
    emitEmail() {
      if (this.radioValue === "other") {
        if (this.email && this.email.length > 0) {
          this.$refs.form.validate().then((res) => {
            if (res) {
              this.$emit("send", this.email);
            }
          });
        }
      } else {
        this.$emit("send", this.radioValue);
      }
    },
  },
};
</script>
